import { render, staticRenderFns } from "./OverviewRecords.vue?vue&type=template&id=9bacf0e4&"
import script from "./OverviewRecords.vue?vue&type=script&lang=js&"
export * from "./OverviewRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports